import { ChartBoxIcon } from './ChartBoxIcon';

/**
 * author: Google
 * id 381420B2-B2EE-4E9F-9DEA-EA0C1F92A226
 * name chart-box
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-box.svg
 * tags
 * - Math 
 */
export const PollBoxIcon = ChartBoxIcon;
export default PollBoxIcon